var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CreateTicimaxV2Channel" } }, [
    _c(
      "div",
      { staticClass: "ticimax-container" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "a-form",
          { staticClass: "ticimax-form" },
          [
            _c(
              "a-form-item",
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("Domain Adresi"),
                ]),
                _vm._v(" "),
                _c(
                  "a-input",
                  {
                    attrs: { size: "large", autocomplete: "off" },
                    model: {
                      value: _vm.form.domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "domain", $$v)
                      },
                      expression: "form.domain",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "global" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("API Kullanıcı Adı"),
                ]),
                _vm._v(" "),
                _c(
                  "a-input",
                  {
                    attrs: { size: "large", autocomplete: "off" },
                    model: {
                      value: _vm.form.apiUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "apiUser", $$v)
                      },
                      expression: "form.apiUser",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "user" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c("label", { staticClass: "form-label" }, [_vm._v("API Key")]),
                _vm._v(" "),
                _c(
                  "a-input",
                  {
                    attrs: { size: "large", autocomplete: "off" },
                    model: {
                      value: _vm.form.apiKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "apiKey", $$v)
                      },
                      expression: "form.apiKey",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "key" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button-group" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "default", size: "large" },
                    on: { click: _vm.handleCancel },
                  },
                  [_vm._v("\n                    Vazgeç\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "large",
                      disabled: _vm.loading,
                    },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm.loading
                      ? [_c("a-spin")]
                      : [
                          _vm._v(
                            "\n                        Bağlan\n                    "
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-container" }, [
      _c("img", {
        staticClass: "ticimax-logo",
        attrs: { src: "/static/img/ticimax.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-box" }, [
      _c("p", [
        _vm._v(
          "\n                Ticimax panel URL'niz üzerindeki\n                "
        ),
        _c("span", { staticClass: "highlighzt" }, [
          _vm._v("https://"),
          _c("span", { staticClass: "highlighted-part" }, [
            _vm._v("www.example.com"),
          ]),
          _vm._v("/admin/"),
        ]),
        _vm._v(
          "\n                kısmını domain kısmına yazmanız gerekiyor.\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }